import React from "react";
var __jsx = React.createElement;
import { useState } from "react";
import stl from "./LatestPosts.module.css";
import BoxLoading from "@componentsShared/placeholders/BoxLoading/BoxLoading";
import SubmitButton from "@componentsShared/buts/SubmitButton/SubmitButton";
import ArrowSVG from "../../../../SVGObjects/UiKit/ArrowSVG";
import BottomSheetPopup from "@componentsShared/BottomSheetPopup__OLD/BottomSheetPopup";
import GrantedPopup from "../../../../components/SearchComponent/NewComponents/GrantedPopup/GrantedPopup";
import useHelpers from "@hooks/useHelpers";
import { ModernCard } from "@/components/SearchComponent/ModernCard";
var LatestPosts = function LatestPosts(_ref) {
  var title = _ref.title,
    posts = _ref.posts,
    _ref$lazyOnly = _ref.lazyOnly,
    lazyOnly = _ref$lazyOnly === void 0 ? false : _ref$lazyOnly,
    _ref$hasArrow = _ref.hasArrow,
    hasArrow = _ref$hasArrow === void 0 ? false : _ref$hasArrow,
    buttonText = _ref.buttonText,
    buttonUrl = _ref.buttonUrl,
    buttonColor = _ref.buttonColor,
    _ref$eagerImgNum = _ref.eagerImgNum,
    eagerImgNum = _ref$eagerImgNum === void 0 ? 8 : _ref$eagerImgNum,
    _ref$CustomTag = _ref.CustomTag,
    CustomTag = _ref$CustomTag === void 0 ? "h2" : _ref$CustomTag;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var _useState = useState(false),
    showGrantedPopup = _useState[0],
    setShowGrantedPopup = _useState[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.CLO_component
  }, title && /*#__PURE__*/React.createElement("h2", null, title), /*#__PURE__*/React.createElement("div", {
    className: stl.CLO_postsContainer
  }, posts.length ? posts === null || posts === void 0 ? void 0 : posts.map(function (post, idx) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ModernCard, {
      post: post,
      key: post.id,
      showGrantedPopup: function showGrantedPopup() {
        return setShowGrantedPopup(true);
      }
    }));
  }) : /*#__PURE__*/React.createElement(BoxLoading, {
    divHeight: 325,
    numberOfLoaders: "8",
    hasCar: true
  })), /*#__PURE__*/React.createElement(SubmitButton, {
    className: "redBtn ".concat(stl.customBtn, " ").concat(buttonColor ? buttonColor : "", " ").concat(hasArrow ? stl.customBtnFlex : ""),
    onClick: function onClick() {
      return navigateTo(buttonUrl);
    },
    loading: false
  }, buttonText, hasArrow && /*#__PURE__*/React.createElement(ArrowSVG, {
    filledColor: "white",
    className: "m-show ".concat(stl.rotateTheSVG)
  }))), /*#__PURE__*/React.createElement(BottomSheetPopup, {
    show: showGrantedPopup,
    onClose: function onClose() {
      return setShowGrantedPopup(false);
    }
  }, /*#__PURE__*/React.createElement(GrantedPopup, null)));
};
export default LatestPosts;